// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'lib-flexible/flexible'
import axios from 'axios'
import less from 'less'
import "@/assets/css/currency.css"

// 异步请求
// 异步请求
import {
  httpPost,
  httpGet,
} from '../http.js'
Vue.prototype.$httpPost = httpPost;
Vue.prototype.$httpGet = httpGet;

Vue.use(less)
Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false
// Vue.config.publicPath='/'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title && to.path !== 'ProductDetail') {
    const lang = localStorage.getItem('tfl-lang') || 'zh'
  // =  === 'en' ? to.meta.enTitle :
    if (lang === 'zh') {
      document.title = to.meta.title;
    } else if (lang === 'en') {
      document.title = to.meta.enTitle;
    } else {
      document.title = to.meta.enTitle;
    }
  };

  next()
})

import i18n from '@/i18n'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js